import React, { FunctionComponent } from "react";
import useStyles from "./styles";
import { TableProps } from "./types";

import { Card, CardHeader, Avatar, CardContent } from "@material-ui/core";
import { TableChart, ZoomIn } from "@material-ui/icons";

const TableWrapper: FunctionComponent<TableProps> = ({
  title,
  style,
  children
}) => {
  const classes = useStyles();

  return (
    <Card style={style}>
      <CardHeader
        title={title}
        className={classes.header}
        avatar={
          <Avatar aria-label={title} className={classes.avatar}>
            <TableChart />
          </Avatar>
        }
        /*      action={
        <IconButton aria-label="zoom" onClick={() => setGrid(12)}>
          <ZoomIn />
        </IconButton>
      }*/
      />
      <CardContent className={classes.tableWrapper}>{children}</CardContent>
    </Card>
  );
};

export default TableWrapper;
